import { CountUp } from 'countup.js';

let items = document.querySelectorAll('[data-countup]');

if (items) {
    createObserver();
}

function createObserver() {
    let observer;

    let options = {
        root: null,
        rootMargin: '0px',
    };

    observer = new IntersectionObserver(handleIntersect, options);
    items.forEach((item) => {
        observer.observe(item);
    });
}


function handleIntersect() {
    items.forEach((item) => {
        let countUp;
        let options = {};
        let number = item.dataset.countup;
        let numbertmp = number;
        number = number.replace('%', '');

        if (number === numbertmp) {
            options = {
                duration: 3,
            };
        } else {
            options = {
                duration: 3,
                suffix: '%',
            };
        }

        countUp = new CountUp(item, number, options);

        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/countup.js